<template>
    <button v-bind="$attrs" class="appearance-none rounded-none focus:outline-none" @click.prevent="onOpen">
        <slot />
    </button>

    <teleport to="body">
        <dialog v-if="isWarningOpen" class="cultural-warning-dialog">
            <cultural-warning :required="true" @agree="onAgree" />
        </dialog>
    </teleport>
</template>

<script>
    import GLightbox from 'glightbox';
    import CulturalWarning from './CulturalWarning.vue';
    import { hasAgreed, setAgreed } from '@utils/cultural-warning';

    export default {
        components: {
            CulturalWarning,
        },

        inheritAttrs: false,

        props: {
            provider: {
                type: String,
                default: '',
            },
            type: {
                type: String,
                required: true,
            },
            href: {
                type: String,
                required: true,
            },
            closeOnFinish: {
                type: Boolean,
                default: false,
            },
            culturalWarning: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                lightbox: null,
                isWarningOpen: false,
            };
        },

        mounted() {
            const elem = {
                href: this.href,
                type: this.type,
            };

            if (this.provider) {
                elem.source = this.provider;
            }

            this.lightbox = GLightbox({
                elements: [elem],
            });

            if (this.closeOnFinish) {
                this.lightbox.on('slide_changed', ({ current }) => {
                    const { player } = current;

                    if (player) {
                        player.on('ended', () => {
                            window.location = '/videos';
                        });
                    }
                });
            }
        },

        beforeUnmount() {
            this.lightbox.destroy();
        },

        methods: {
            onOpen() {
                // Gate before opening, never over the top: GLightbox autoplays its player.
                if (this.culturalWarning && !hasAgreed()) {
                    this.isWarningOpen = true;

                    return;
                }

                this.lightbox.open();
            },
            onAgree() {
                setAgreed();
                this.isWarningOpen = false;
                this.lightbox.open();
            },
        },
    };
</script>

<style>
    .plyr__poster {
        z-index: -500000 !important;
    }
</style>
